import React from "react";
import ExcelContainer from '../../Containers/ExcelContainer';


const ExcelAdd = (props) => {
	return (
		<ExcelContainer page="excelDetail"/>
	);
}

export default ExcelAdd;